// Import the RTK Query methods from the React-specific entry point
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Update TB to retrieve coachmarks from the following urls
// Prod: https://new.express.adobe.com/static/coachmarks/coachmarks.json
// Stage: https://stage.projectx.corp.adobe.com/static/coachmarks/coachmarks.json

// Define our single API slice object
export const coachmarksSlice = createApi({
    reducerPath: 'coachmarks',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.EXPRESS_COACHMARK_URL,
    }),
    endpoints: (builder) => ({
        getCoachmarks: builder.query({
            query: () => '/static/coachmarks/coachmarks.json',
        }),
    }),
});

export const { useGetCoachmarksQuery } = coachmarksSlice;
